module.exports = __webpack_public_path__ + "static/media/calendar-2.3c77d299.svg";